var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStars2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143.125,
    height: 66.162,
    viewBox: "0 0 143.125 66.162",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1107.104 -6256.137)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1054.122,6308.3l.742,2.931-2.928.742a3.02,3.02,0,0,0-2.187,3.671,3.022,3.022,0,0,0,3.672,2.189l2.929-.742.742,2.929a3.022,3.022,0,0,0,3.673,2.186,3.02,3.02,0,0,0,2.187-3.671l-.742-2.929,2.931-.743a3.024,3.024,0,0,0,2.186-3.674,3.021,3.021,0,0,0-3.671-2.186l-2.931.743-.743-2.931a3.022,3.022,0,0,0-3.672-2.187,3.023,3.023,0,0,0-2.188,3.672Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-977.275,6262.427l.743,2.931-2.931.743a3.022,3.022,0,0,0-2.187,3.672,3.023,3.023,0,0,0,3.672,2.188l2.931-.742.742,2.928a3.021,3.021,0,0,0,3.672,2.187,3.022,3.022,0,0,0,2.188-3.672l-.742-2.929,2.929-.742a3.023,3.023,0,0,0,2.186-3.673,3.021,3.021,0,0,0-3.671-2.187l-2.929.742-.743-2.931a3.025,3.025,0,0,0-3.673-2.186,3.021,3.021,0,0,0-2.187,3.671Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1089.432,6262.792a3.023,3.023,0,0,0-3.672-2.189l-2.929.742-.742-2.929a3.024,3.024,0,0,0-3.674-2.186,3.021,3.021,0,0,0-2.187,3.671l.743,2.929-2.931.743a3.023,3.023,0,0,0-2.186,3.674,3.021,3.021,0,0,0,3.671,2.186l2.931-.743.743,2.932a3.022,3.022,0,0,0,3.671,2.186,3.024,3.024,0,0,0,2.189-3.672l-.743-2.931,2.929-.742a3.021,3.021,0,0,0,2.187-3.671Zm0,0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStars2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stars-2.5919efc9.svg";
export { ForwardRef as ReactComponent };